import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne, axiosWhitelabeled } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  editHashtagsRoute,
  getAllhashtagsRoute,
  getHashtagsRoute,
  postHashtagsRoute,
} from '../../utils/apiRoutes';

export const getAllHashtagsAsync = createAsyncThunk(
  `${moduleName}/GET/hashtags`,
  async (paylaod, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'GET',
        url: getAllhashtagsRoute(),
      });
      const response2 = await axiosBuzzOne({
        method: 'GET',
        url: getHashtagsRoute(),
      });

      const data = {
        hashtags: response.data.data,
        popularHashtags: response2.data.data.popularHashtags,
      };
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addHashtagAsync = createAsyncThunk(
  `${moduleName}/POST/hashtag`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosBuzzOne({
        method: 'POST',
        url: postHashtagsRoute(),
        data: payload,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateHashtagAsync = createAsyncThunk(
  `${moduleName}/PUT/hashtag`,
  async (payload, { rejectWithValue }) => {
    try {
      const { id, data } = payload;
      const response = await axiosBuzzOne({
        method: 'PUT',
        url: editHashtagsRoute(id),
        data,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const HashtagsSlice = createSlice({
  name: `${moduleName}/AppList`,
  initialState: {
    loading: false,
    hashtags: [],
  },
  reducers: {},
  extraReducers: {
    [getAllHashtagsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllHashtagsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      const { hashtags, popularHashtags } = action.payload;

      state.hashtags = hashtags
        .map((hashtag) => {
          if (popularHashtags.includes(hashtag.text)) hashtag.isTrending = true;
          else hashtag.isTrending = false;
          return hashtag;
        })
        .sort((a, b) => {
          if (a.createdAt.split('T')[0] < b.createdAt.split('T')[0]) return 1;
          else if (a.createdAt.split('T')[0] > b.createdAt.split('T')[0])
            return -1;
          return 0;
        })
        .sort((a, b) => {
          if (state.hashtags.length > 0) return 0;

          if (!a.isActive && b.isActive) return 1;
          else if (a.isActive && !b.isActive) return -1;
          return 0;
        })
        .sort((a, b) => {
          if (!a.isTrending && b.isTrending) return 1;
          else if (a.isTrending && !b.isTrending) return -1;
          return 0;
        });
    },
    [getAllHashtagsAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default HashtagsSlice.reducer;
